import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateOrEditBrandThemeModal from '@modals/CreateOrEditBrandThemeModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    PageFilterModal: {
      closeModal: () => setState({ showPageFilterModal: false }),
      updateFilters: filters => setState({ pageFilters: filters, showPageFilterModal: false }),
    },
    CreateOrEditBrandThemeModal: {
      closeModal: () => setState({ showCreateOrEditBrandThemeModal: false }),
      createBrandTheme: payload => handleCallbackAction(payload),
      updateBrandTheme: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrEditBrandThemeModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditBrandThemeModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrEditBrandThemeModal: (payload) => {
        setModalData('CreateOrEditBrandThemeModal', payload)
        setState({ showCreateOrEditBrandThemeModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrEditBrandThemeModal
          callbacks={callbacks('CreateOrEditBrandThemeModal', setState)}
          showModal={showCreateOrEditBrandThemeModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
